export function uniqueArray(arr) {
  const temp = [];
  const uuidList = [];
  arr.forEach((item) => {
    if (uuidList.includes(item.uuid)) {
      return;
    }
    temp.push(item);
    uuidList.push(item.uuid);
  });
  return temp;
}

export function uniqueObjArray(arr, uniId) {
  const res = new Map();
  return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
}

export const parseMixModel = (mixModel) => {
  if (!mixModel) {
    return [];
  }

  if (Array.isArray(mixModel)) {
    return mixModel;
  }
  let parsed = null;

  try {
    parsed = JSON.parse(mixModel);
  } catch (ex) {
    // do nothing
  }

  if (parsed && Array.isArray(parsed)) {
    return parsed;
  }

  return [];
};

export const stringifyMixModel = (mixModel) => {
  if (!mixModel) {
    return '';
  }
  if (typeof mixModel === 'string') {
    return mixModel;
  }
  return JSON.stringify(mixModel);
};
